export default __webpack_public_path__ + "assets/images/39a62b27e9c27b9a4dd0b85b0991a7d2-message-icon.svg";